import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AngularFireModule } from '@angular/fire';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SalesNavComponent } from './sales-nav/sales-nav.component';
import { FormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule, MatDialogModule, MatButtonModule, MatSelectModule, MatFormFieldModule, MatInputModule, MatSidenavModule, MatIconModule, MatListModule, MatGridListModule, MatCardModule, MatMenuModule, MatTableModule, MatPaginatorModule, MatSortModule, MatCheckboxModule} from '@angular/material';
import { SalesDashboardComponent } from './sales-dashboard/sales-dashboard.component';
import { SalesTableComponent } from './sales-table/sales-table.component';
import { SalesAnalyticsComponent } from './sales-analytics/sales-analytics.component';
//import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { FirestoreService } from './services/firestore.service';
import { SalesLeadsService } from './services/sales-leads.service';
import { environment } from '../environments/environment';
import { GenericDialogComponent } from './generic-dialog/generic-dialog.component';
import { LeadsUploadComponent } from './leads-upload/leads-upload.component';
import { SelectAgentDialogComponent } from './select-agent-dialog/select-agent-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    SalesNavComponent,
    SalesDashboardComponent,
    SalesTableComponent,
    SalesAnalyticsComponent,
    GenericDialogComponent,
    LeadsUploadComponent,
    SelectAgentDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    FormsModule,
    LayoutModule,
    MatToolbarModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule
  ],
  providers: [
    SalesLeadsService,
    FirestoreService
  ],
  bootstrap: [AppComponent],
  entryComponents: [GenericDialogComponent, SelectAgentDialogComponent]
})
export class AppModule { }
